/**
 * @flow
 */

export default class ClientError extends Error {}
